"use client";

import { Mail, Phone, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const footer = useRevealOnScroll<HTMLDivElement>();
  const channels = [{
    type: "emergency",
    icon: PhoneCall,
    label: "[ LÍNEA DIRECTA ]",
    heading: "¿Reserva urgente o consulta de última hora?",
    contact: "+34 613 13 47 37",
    contactHref: "tel:+34600000000",
    hours: "Disponible para sesiones profesionales"
  }, {
    type: "general",
    icon: Phone,
    label: "[ WHATSAPP & INSTAGRAM ]",
    heading: "Hablar sobre tu visión",
    contact: "+34 613 13 47 37\n@nikib.makeup",
    contactHref: "https://wa.me/34600000000",
    hours: "Respuesta dentro de 24 horas"
  }, {
    type: "email",
    icon: Mail,
    label: "[ ENVIAR EMAIL ]",
    heading: "Editorial & colaboración",
    contact: "nikibarrios7@gmail.com",
    contactHref: "https://mail.google.com",
    hours: "Respuesta dentro de 24 horas"
  }];
  return <section data-section-id="855" id="get-in-touch" className="bg-background text-foreground">
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:px-8 lg:py-28">
        {}
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs sm:text-sm tracking-[0.25em] uppercase mb-6 text-secondary">
            [ CONECTA CON NIKI ]
          </p>
          <h2 className="font-serif font-default text-foreground leading-[1.05]" style={{
          fontSize: "clamp(2.5rem, 5vw, 4rem)"
        }}>
            ¿Listo para{" "}
            <span className="italic text-primary">
              crear?
            </span>
          </h2>
          <p className="mt-6 font-sans text-base sm:text-lg leading-relaxed text-secondary">Ya sea para una sesión de modelo profesional o un evento especial, conversemos sobre cómo puedo hacer realidad tu visión.</p>
        </div>

        {}
        <div ref={grid.ref} className={`mt-16 sm:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-700 ease-out delay-150 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {channels.map((channel, i) => {
          const Icon = channel.icon;
          const isEmergency = channel.type === "emergency";
          return <div key={channel.type} data-index={i} className={`group relative flex flex-col rounded-lg p-10 lg:p-12 transition-all duration-300 hover:-translate-y-1 ${isEmergency ? "bg-secondary text-secondary-foreground" : "border border-border bg-card"}`}>
                {}
                <div className="mb-8">
                  <Icon className="h-12 w-12" strokeWidth={1.25} style={{
                color: isEmergency ? "hsl(32, 44%, 52%)" : "hsl(32, 44%, 52%)"
              }} aria-hidden="true" />
                </div>

                {}
                <p className="font-mono text-xs tracking-[0.2em] uppercase mb-5 text-muted-foreground">
                  {channel.label}
                </p>

                {}
                <h3 className="font-serif font-default text-2xl sm:text-[1.6rem] leading-tight mb-6">
                  {channel.heading}
                </h3>

                {}
                <Link to={channel.contactHref} className="font-serif font-default leading-tight break-words transition-opacity hover:opacity-80 text-primary" style={{
              fontSize: channel.type === "email" ? "1.5rem" : "2rem"
            }}>
                  {channel.contact}
                </Link>

                {}
                <div className="mt-8 mb-5 h-px w-full bg-border" />

                {}
                <p className="font-sans text-sm leading-relaxed text-muted-foreground">
                  {channel.hours}
                </p>

                {}
                <span className="pointer-events-none absolute bottom-0 left-10 right-10 h-px origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100 bg-primary" aria-hidden="true" />
              </div>;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-16 sm:mt-20 flex items-center justify-center gap-3 transition-all duration-700 ease-out delay-300 ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75 bg-primary" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-lg bg-primary" />
          </span>
          <p className="font-serif font-default italic text-lg sm:text-xl text-foreground">
            Disponible para reservas en Valencia y Madrid.
          </p>
        </div>
      </div>
    </section>;
}